import { t } from 'i18next';
import * as yup from 'yup';

import { numberSchemaWithTransform } from 'core/yup';

export const upsertBomComponentSchema = () =>
  yup.object().shape({
    component: yup
      .object()
      .shape({
        name: yup.string().label(t('labelComponent')).required(),
      })
      .label(t('labelComponent'))
      .nullable()
      .required(),
    manufacturer: yup.object().label(t('labelManufacturer')).nullable(),
    quantity: numberSchemaWithTransform()
      .label(t('labelQuantity'))
      .min(0, t('labelQuantity'))
      .required(),
    uom: yup.string().label(t('labelUom')).nullable().required(),
  });
